module.exports = __webpack_public_path__ + "static/media/1983.d643ed59.svg";